<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">预约资源管理</h2>
		</div>
		<el-header style="height: 125px;">
			<ul style="float: left;text-align: left;">
				<li>
					分院:&emsp;<el-select v-model="curbranchid" placeholder="请选择分院" style="width: 200px;">
						<el-option v-for="item in branchlist" :label="item.branch_name" :value="item.branch_id">
							{{ item.branch_name }}
						</el-option>
					</el-select>
					&emsp;日期:&emsp;<el-date-picker style="width: 140px;" v-model="datestart" type="date"
						format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>&emsp;到&emsp;
					<el-date-picker style="width: 140px;" v-model="dateend" type="date" format="yyyy-MM-dd"
						value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>
				</li>
				<li>
					<el-button @click="btnQ()">查询已设置资源</el-button>
					<el-button @click="btnSave()">批量保存预约资源</el-button>
				</li>
			</ul>

		</el-header>
		<el-main>


			<el-table tooltip-effect="dark" :data="BranchBookCapacityData">
				<el-table-column prop="book_date" label="日期" width="120px" :formatter="dateFormat">

				</el-table-column>
				<el-table-column prop="type_name" label="分类名称" width="200px"></el-table-column>
				<el-table-column prop="timestep" label="时间段" width="100px"></el-table-column>
				<el-table-column prop="capacity" label="预约资源量" width="100px"></el-table-column>
				<el-table-column label="操作" width="250px">
					<template slot-scope="scope">
						<el-button @click="btnEditCapacity(scope.row)" icon="el-icon-save" type="text">修改</el-button>
						预约量：<el-input type='number' style="width: 80px;" v-model="scope.row.capacity"></el-input>
					</template>
				</el-table-column>
			</el-table>

		</el-main>
	</div>
</template>

<script>
	import enums from '../../commontools/enums.js'
	import book from '../../apifunction/Book.js'
	import branch from '../../apifunction/Branch.js'
	export default {
		data() {
			return {
				branchlist: [],
				BranchBookCapacityData: [],
				curbranchid: '',
				datestart: this.CommonFun.GetNowDate(),
				dateend: this.CommonFun.GetNowDate()
			}
		},
		mounted() {
			this.GetBranchAll();
		},
		methods: {
			dateFormat: function(row, column) {
				var date = new Date(row[column.property]);
				if (date == undefined) {
					return ''
				};
				return this.CommonFun.GetMyDate(date);
			},
			GetBranchAll() {
				branch.GetAllBranch()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.branchlist = JSON.parse(ent.Data);
							if (this.branchlist.length > 0)
								this.curbranchid = this.branchlist[0].branch_id;

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnQ() {
				if (this.curbranchid == '' || this.datestart == null || this.dateend == null) {
					this.$message.info('请选择查询分院和日期！');
					return;
				}
				book.GetBranchBookCapacity(this.curbranchid, this.datestart, this.dateend)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BranchBookCapacityData = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnSave() {
				if (this.curbranchid == '' || this.datestart == null || this.dateend == null) {
					this.$message.info('请选择分院和日期！');
					return;
				}
				this.CommonFun.ShowLoading('保存中，请稍后...')
				book.SaveBranchBookCapacity(this.curbranchid, this.datestart, this.dateend)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info("保存成功！");

						} else
							this.$message.info(ent.Msg);
						this.CommonFun.CloseLoading();
					})

			},
			btnEditCapacity(row) {
				var info = {
					branch_id: this.curbranchid,
					book_type_id: row.book_type_id,
					capacity: row.capacity,
					book_date: row.book_date
				}
				book.EditBranchBookCapacity(info)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info("修改成功！");

						} else
							this.$message.info(ent.Msg);
					})
			}
		}
	}
</script>

<style>
</style>
